/**
 * @generated SignedSource<<2ea2add60a6703f991ea03b949673deb>>
 * @relayHash 6b6ec52bc42f01c0a8eb6b15b8c851f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b257e7d499c8b7fdea0dfb8b8a703b69cca20edde6479c4f62ea2d25e44688f

import type { ConcreteRequest } from 'relay-runtime';
export type ExcerptIncludeTargetPageByIdQuery$variables = {
  contentId: string;
};
export type ExcerptIncludeTargetPageByIdQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type ExcerptIncludeTargetPageByIdQuery = {
  response: ExcerptIncludeTargetPageByIdQuery$data;
  variables: ExcerptIncludeTargetPageByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ExcerptIncludeTargetPageByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExcerptIncludeTargetPageByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b6ec52bc42f01c0a8eb6b15b8c851f9",
    "id": "5b257e7d499c8b7fdea0dfb8b8a703b69cca20edde6479c4f62ea2d25e44688f",
    "metadata": {},
    "name": "ExcerptIncludeTargetPageByIdQuery",
    "operationKind": "query",
    "text": "query ExcerptIncludeTargetPageByIdQuery($contentId:ID!){content(id:$contentId){nodes{id,body{atlas_doc_format{value}}}}}"
  }
};
})();

(node as any).hash = "9bbc89ccb85c7dc3bd4c26141d0f7627";

export default node;
